/**
 * http://usejsdoc.org/
 */
import React, { Component } from 'react';
import {
	Card, CardBody, CardHeader, Button, Col, Row, Label
} from 'reactstrap';
import { Control, LocalForm } from 'react-redux-form';
import jumpersStore from '../../../stores/jumpers-store';
import { components } from 'react-select';
import AsyncSelect from 'react-select/lib/Async';

import loadsStore from '../../../stores/loads-store';
import { ClipLoader } from 'react-spinners';
import Fuse from "fuse.js";
import ReactDOM from 'react-dom';
import swal from 'sweetalert';

const customStyles = {
	control: (base, state) => ({
		...base,
		fontSize: "1.2em"
	}),
   dropdownIndicator: (base) => ({
			...base,
			padding: "0px", 
		  }),
		  clearIndicator: (base) => ({
			...base,
			padding: "0px",
		  }),
	}


class CreateFunJumpCard extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showModal: true,
			setJumperName: null,
			isModalOpen: false,
			jumpType: null,
			affLevel: null,
			load: props.load,
			isloading: false,
			ErrorMessage: '',
			isValid: true,
			jumpType: "Undecided",
			jumpers: [],
			isClosed: false,
			lowPass: false,
			trackingFirstOut: false,
			menuPlacement: "bottom",
			menuIsOpen: true,
			suggestions: [],
			jumperOptions: [],
		};
		this.inputValue = '';
		this.studentgearIds = [];
		this.sportgearIds = [];

		this.jumpersInput = {};
		//this.timerId;
		this.fuse = null;
		this.handleNewActivity = this.handleNewActivity.bind(this);
		this.loadEvents = [
			{ name: loadsStore.getEventPrefix('loaderActivity'), func: this.handleNewActivity },
		];
		this.JumpType = ['Wingsuit', 'Belly', 'Freefly', 'Tracking', 'HopNPop', 'HopNPop Student', 'Solo Student', 'High Pull']

	}


	componentWillMount = () => {
		// console.log('CreateJump componentWillMount');
		this.loadEvents.forEach((evnt) => loadsStore.on(evnt.name, evnt.func));
		//this.timerId = setTimeout(this.cancelOrSubmit, 5000); // call the `toggle` function after 5000ms
	}

	cancelOrSubmit = () => {
		// console.log(this.valRef.val);

		// console.log(this.state.jumpType);
		// console.log(this.gearIds);
		//alert("jump type: " + JSON.stringify(this.state.jumpers));
		//this.gearIds = this.gearIds.filter(id => )

		if (this.state.jumpers.length > 0) {
			var jumpType;


			//if (this.state.jumpType === "Undecided") jumpType = 'Undecided';
			//else jumpType = this.props.jumpType

			var jumpPostBody = {
				jumpType: this.props.jumpType,
				jumperIds: this.state.jumpers.map(jumperOption => jumperOption.value._id),
				isClosed: this.state.isClosed,
				lowPass: this.state.lowPass,
				trackingFirstOut: this.state.trackingFirstOut,
				altitude: loadsStore.getDefaultAltitude().name
			};

			if (this.props.jumpType === "HopNPop" || this.props.jumpType === 'HopNPop Student') {
				jumpPostBody.altitude = loadsStore.getLowAltitude().name;
			}

			jumpPostBody.studentgearRentals = this.studentgearIds.filter(id => jumpPostBody.jumperIds.indexOf(id) >= 0);
			jumpPostBody.sportgearRentals = this.sportgearIds.filter(id => jumpPostBody.jumperIds.indexOf(id) >= 0);

			// console.log(jumpPostBody.gearRentals);
			// console.log(jumpPostBody);
			// alert(JSON.stringify(jumpPostBody));
			jumpPostBody.jumperIds = Array.from(new Set(jumpPostBody.jumperIds));

			loadsStore.createFunJump(this.state.load.loadNum, jumpPostBody);
		}
		else {
			this.setState({
				isloading: false,
				ErrorMessage: 'Invalid Input !',
				isValid: false
			})

			//this.formDispatch(actions.reset('createjump.jumpers'));
		}

		this.cancelCreateJump();
	}

	componentWillUnmount = () => {
		this.loadEvents.forEach((evnt) => loadsStore.removeListener(evnt.name, evnt.func));
	}

	async componentDidMount() {

			//alert('componentDidUpdate');
			// console.log(this.valRef);
			this.valRef.focus();
			ReactDOM.findDOMNode(this.valRef).focus();


			var jumperOptions = jumpersStore.getJumperOptions()
			if(this.props.activeJumperIdsOnLoad){
						jumperOptions = jumperOptions.filter(
							option =>
								this.props.activeJumperIdsOnLoad.findIndex(
									id => option.value._id === id
								) === -1
						);
					}
			this.setState({jumperOptions: jumperOptions});
			this.setFuse(jumperOptions);


		  if (ReactDOM.findDOMNode(this.valRef).getBoundingClientRect().y > window.innerHeight / 2) {
				this.setState({ menuPlacement: "top" });
			}
			else {
				this.setState({ menuPlacement: "bottom" });
			}

	}

	setFuse = (jumperOptions) => {
		console.log('in set Fuse');
		var options = {
			shouldSort: true,
			tokenize: false,
			threshold: 0.1,
			location: 0,
			distance: 100,
			maxPatternLength: 32,
			minMatchCharLength: 1,
			keys: [
				"label",
				"value.manifestNumber"
			]
		};
		console.log(jumperOptions);
		this.fuse = new Fuse(jumperOptions, options); // "list" is the item array
	}

	handleNewActivity = (activityString) => {
		// console.log('in handleNewActivity');
		// console.log(activityString);
		if (activityString) {
			this.setState({
				isloading: false,
				isModalOpen: false
			})
		}
	}

	updateGear = (value) => {
		// console.log(value);
		// console.log(value.target);

		var id = value.target.name.substr(5);
		var type = value.target.name.substr(0, 5);
		//alert('gear click ' + value.target.checked);

		if (type === "gear1") {
			if (value.target.checked) {
				this.studentgearIds.push(id);
			}
			else {
				this.studentgearIds = this.studentgearIds.filter(gearId => gearId !== id);
			}
		}
		else if (type === "gear2") {
			if (value.target.checked) {
				this.sportgearIds.push(id);
			}
			else {
				this.sportgearIds = this.sportgearIds.filter(gearId => gearId !== id);
			}
		}
		// console.log(this.gearIds);
	}

	// handleNewActivity =(activityString)=>{
	// 	console.log('in handleNewActivity');
	//     console.log(activityString);
	//     if(activityString)
	//     {
	//         this.setState({
	//             isloading: false,
	//             isModalOpen: false
	//         })
	//     }
	// }

	Option = (props) => {

		var studentgearModel = ".gear1" + props.data.value._id;
		var studentname = "gear1" + props.data.value._id;

		var sportgearModel = ".gear2" + props.data.value._id;
		var sportname = "gear2" + props.data.value._id;
		const {fSize} = JSON.parse(localStorage.getItem('jumperDetails'));
		let fontSize = fSize + 1;
		return (
			<React.Fragment>
				<div className="row">
					<div className="col-6" style={{fontSize: `${fontSize}px`}}>
						<components.Option {...props} />
					</div>

					<div className="col-3" style={{ paddingTop: '6px',fontSize: `${fontSize}px` }}>
						<div className="row">
							student gear <Control.checkbox model={studentgearModel} name={studentname} onChange={value => { this.updateGear(value) }} />
						</div>
						<div className="row" style={{ paddingTop: '6px',fontSize: `${fontSize}px` }}>
							sport gear rent <Control.checkbox model={sportgearModel} name={sportname} onChange={value => { this.updateGear(value) }} />
						</div>
					</div>


				</div>
				<br />
			</React.Fragment>
		);
	}

	MultiValueLabel = (props) => {
		// console.log(props);
		// console.log(props.data);

		return (
			<div className="row" style={{margin:'0px',width:'103px'}}>
				<div className="col-12" title={props.children}><components.MultiValueLabel {...props} /></div>
				{this.studentgearIds.indexOf(props.data.value._id) > -1 || this.sportgearIds.indexOf(props.data.value._id) > -1 ? <div className="col-12">-G</div> : null}
			</div>
		);
	}

	filterJumpers = (inputValue, jumperOptions) => {
		console.log("in filterJumpers");
		console.log(inputValue);
		if (inputValue) {
			// console.log(inputValue);
			/*
			var filteredOptions = jumperOptions.filter(i =>
					  i.label.toLowerCase().match(inputValue.toLowerCase()));*/
			// console.log('before useing fuse');
			//var test = jumpersStore.test();
			var filteredOptions = this.fuse.search(inputValue.toLowerCase());

			console.log(filteredOptions);
			//alert('after fuse');
			//console.log(filteredOptions);
			if (filteredOptions.length > 30) return filteredOptions = filteredOptions.slice(0, 30);
			else return filteredOptions;
		}
		return jumperOptions;
	};

	promiseOptions = (inputValue, jumperOptions) => {
		// console.log('in pomiseOptions');
		// console.log(this.state.inputValue);
		return new Promise(resolve => {
			resolve(this.filterJumpers(this.inputValue, jumperOptions));
		});
	}

	handleInputChange = (newValue) => {
		// console.log('handleInputChange');
		const inputValue = newValue
		// const inputValue = newValue.replace(/\W/g, '');
		this.promiseOptions(newValue, this.props.jumperOptions);
		this.inputValue = newValue;
		//clearTimeout(this.timerId);
		//this.timerId = setTimeout(this.cancelOrSubmit, 5000);
		this.valRef.focus();

		return inputValue;
	};

	onRadioBtnClick = (rSelected) => {
		var jumpType = this.JumpType;

		this.setState({
			rSelected,
			jumpType: jumpType[rSelected - 1]
		});
	}

	handleChange = (values) => {
		//alert(JSON.stringify(values));

		var jumpers = values;
		if (this.props.jumpType === "Solo Student" || this.props.jumpType === "HopNPop Student" || this.props.jumpType === "HopNPop") {
			jumpers = [values];
		}
		this.valRef.focus();
		console.log('refocus on input box');
		//var suggestions = [this.props.jumperOptions[0], this.props.jumperOptions[1], this.props.jumperOptions[2], this.props.jumperOptions[3]];
		this.setState({ jumpers: jumpers });

		var payload = {
			jumperIds: jumpers.map(value => value.value._id)
		}

		if (!(this.props.jumpType === "Solo Student" || this.props.jumpType === "HopNPop Student" || this.props.jumpType === "HopNPop")) {
			jumpersStore.getJumpWithSuggestions(payload)
				.then(suggestions => {
					suggestions = suggestions.filter(suggestion => this.state.jumpers.findIndex(value => value.value._id === suggestion.value._id) < 0);
					this.setState({ suggestions: suggestions })
				})

		}

	}

	handleCreateFunJump = (values, loadNum) => {
		this.cancelOrSubmit();
		this.setState({ setJumperName: '' })
		//this.cancelCreateJump();
	}

	cancelCreateJump = () => {
		// this.handleJumper(this.props.jumperOptions)
		loadsStore.cancelCreateJump(this.props.load.loadNum);
	}

	updateJumpType = (value) => {
		//clearTimeout(this.timerId);
		//this.timerId = setTimeout(this.cancelOrSubmit, 5000);
		this.setState({ jumpType: value.target.value });
	}

	onIsClosedClick = value => {
		console.log('isclosed click');
		console.log(value.target);
		if (value.target.checked)
			this.setState({ isClosed: true });
		else
			this.setState({ isClosed: false });
	}

	onLowPassClick = value => {
		console.log('lowPass click');
		console.log(value.target);
		if (value.target.checked)
			this.setState({ lowPass: true });
		else
			this.setState({ lowPass: false });
	}

	onFirstOutClick = value => {
		console.log('on first out cllick');
		console.log(value.target);
		if (value.target.checked)
			this.setState({ trackingFirstOut: true });
		else
			this.setState({ trackingFirstOut: false });
	}

	attach = (node) => {
		alert('in get Ref');
		// console.log(node);
		node.focus();
	}

	focusInput = (component) => {
		alert('focusInput');

		// console.log(component);
		if (component)
			component.focus();
	}


	handleJumper = (array) => {
		let jumperDetails = localStorage.getItem("jumperDetails")
		jumperDetails = JSON.parse(jumperDetails)
		let jumpers = array.filter(val => val.value._id == jumperDetails._id)
		// if (this.props.jumpType === "Solo Student" || this.props.jumpType === "HopNPop Student" || this.props.jumpType === "HopNPop") {
		// 	jumpers = [jumpers];
		// }

		if (jumpers && jumpers.length) {
			this.setState({ showModal: true })
			this.setState({ jumpers: jumpers, setJumperName: jumpers[0].label }, () => {
				this.cancelOrSubmit();
			})
		} else {
			this.setState({ showModal: false })
			swal({
				title: "Error",
				text: "Jumper already added",
				icon: "error",
				dangerMode: true,
			})
		}

	}

	addSuggestion = (suggestion) => {
		var jumpers = [...this.state.jumpers, suggestion];
		this.setState({ jumpers: jumpers })

		var payload = {
			jumperIds: jumpers.map(val => val.value._id)
		}
		jumpersStore.getJumpWithSuggestions(payload)
			.then(suggestions => {
				console.log('suggestions: ')
				console.log(suggestions);
				console.log('jumpers: ' + jumpers);
				console.log(jumpers);

				suggestions = suggestions.filter(suggestion => this.state.jumpers.findIndex(value => value.value._id === suggestion.value._id) < 0);
				console.log('suggestions after filter');
				console.log(suggestions);
				this.setState({ suggestions: suggestions })
			})
	}

	render() {

		let { setJumperName, showModal } = this.state

		let AsyncSelectInput = (props) => (<AsyncSelect model={props.model} name={props.name}
			value={props.defaultValue} loadOptions={props.loadOptions} defaultOptions={props.defaultOptions} onChange={props.onChange} isMulti={props.isMulti} components={props.components}
			styles={props.styles} onInputChange={props.onInputChange} menuPortalTarget={props.menuPortalTarget} menuPosition={props.menuPosition} menuPlacement={props.menuPlacement} />);

		//this.setFuse(this.state.jumperOptions);

		const override = `
            display: block;
            margin: 0 auto;
            border-color: red;
            `;
			const customStyles = {
				dropdownIndicator: (base) => ({
					...base,
					padding: "0px", 
				  }),
				  clearIndicator: (base) => ({
					...base,
					padding: "0px",
				  }),
			}

		var isMulti = true;
		if (this.props.jumpType === "Solo Student" || this.props.jumpType === "HopNPop Student" || this.props.jumpType === "HopNPop") {
			isMulti = false;
		}
        const {fontSize} = JSON.parse(localStorage.getItem('jumperDetails'))
		return (
			<div style={{ marginLeft: "0px", width: "99%" }}>
				{
					showModal ?
						<Card className="funjumpcard">
							<CardHeader className="jumpcardheader align-items-center row">
								<div className="col-12">
									<strong>{this.props.jumpType}</strong>
								</div>
								{/* <div className="col-2">
							<i onClick={this.cancelCreateJump} className="fa fa-close"></i>
						</div> */}
							</CardHeader>
							<CardBody className="custom-card-body" style={{ padding: '10px' }}>
								<div className='complete-loading'>
									<ClipLoader
										css={override}
										sizeUnit={"px"}
										size={35}
										color={'#fff'}
										loading={this.state.isloading}
									/>
								</div>
								<LocalForm form="createjump" model="createjump" onSubmit={(values) => this.handleCreateFunJump(values, this.props.load.loadNum)}>

									<Row className="form-group" style={{ paddingLeft: '8px', paddingRight: '7px' }}>
										<Label htmlFor="jumpType" md={12} >Jumpers</Label>
										<Col md={12}>
											{
												setJumperName ?
													''
													// <p style={{ fontWeight:600, fontSize:22 }}> {setJumperName} </p>
													:
													<AsyncSelect model=".jumpers" name="jumpers" loadOptions={(newValue) => this.promiseOptions(newValue, this.props.jumperOptions)} isMulti={isMulti}
														ref={(value) => this.valRef = value}
														onChange={this.handleChange}
														defaultOptions={this.state.suggestions}
														value={this.state.jumpers}
														onInputChange={(newValue) => this.handleInputChange(newValue)}
														components={{ Option: this.Option, MultiValueLabel: this.MultiValueLabel }}
														menuPortalTarget={document.body}
														menuPosition="absolute"
														menuPlacement="top"
														styles={customStyles}
														menuPlacement={this.state.menuPlacement}
														closeMenuOnSelect={true}
													/>
											}
										</Col>
									</Row>
									{/* <Row className="form-group">
								<Col md={12}>
						            Disable Joining    <Control.checkbox model=".isClosed"  name="isClosed" onChange ={(value) => {this.onIsClosedClick(value)}}/>
								</Col>
							</Row> */}

									<Row className="form-group" style={{ paddingLeft: '8px', paddingRight: '7px' }}>
										<Col md={3}>
											Suggestions:
								</Col>
									</Row>
									<Row>
										<Col md={10}>
											{this.state.suggestions.map(suggestion => <Button onClick={() => this.addSuggestion(suggestion)} style={{ fontSize: '16px', marginBottom: '4px', marginLeft: '4px', paddingLeft: '8px', paddingRight: '7px' }}>{suggestion.label}</Button>)}
										</Col>
									</Row>

									{
										this.props.jumpType === "Tracking" ?
											<Row className="form-group" style={{ paddingLeft: '8px', paddingRight: '7px' }}>
												<Col md={12}>
													First out  <Control.checkbox model=".firstOut" name="firstOut" onChange={(value) => { this.onFirstOutClick(value) }} />
												</Col>
											</Row> :
											null
									}
									<Row className="form-group m-t-2-rem">
										<Col md={{ size: 10 }}>
											<button className="btn btn-bg btn-manifest" style={{fontSize: `${fontSize}px`}} type="submit" >MANIFEST</button>
											<button onClick={(e) => { e.preventDefault(); this.cancelCreateJump() }} className="btn btn-link" style={{fontSize: `${fontSize}px`}}>CANCEL</button>
										</Col>
									</Row>
								</LocalForm>
							</CardBody>
						</Card> : ''
				}

			</div>
		);
	}
}

export default CreateFunJumpCard
